import { DialogContent, Typography, Icon, useTheme, Grid } from '../../../base';
import {
    IJobApplication,
    openShareWindow,
    TrackableSourceNames,
} from '../../../common';
import PargodaModal from '../../PargodaModal';
import { ShareButton } from './ShareJobApplicationModal.styles';
import { useTranslation } from 'react-i18next';

interface Props {
    modalTitle: string;
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
    jobApplication: IJobApplication;
}

const ShareJobApplicationModal = (props: Props) => {
    const { isModalOpen, setIsModalOpen, modalTitle, jobApplication } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const shareButtons = [
        { platform: TrackableSourceNames.WHATSAPP, iconName: 'WhatsappIcon' },
        { platform: TrackableSourceNames.EMAIL, iconName: 'MailIcon' },
    ];

    const shareDescription = t('jobApplicationPage.shareCandidateDescription', {
        jobTitle: jobApplication.job?.title,
        interpolation: { escapeValue: false }, // Disable escaping
    });

    const renderShareButton = (button: {
        platform: TrackableSourceNames;
        iconName: string;
    }) => {
        return (
            <ShareButton
                onClick={() => {
                    openShareWindow(
                        button.platform,
                        jobApplication.resumeUrl,
                        `${jobApplication.job?.title} - ${jobApplication.firstName} ${jobApplication.lastName}`,
                        shareDescription,
                        ''
                    );
                    setIsModalOpen(false);
                }}
                key={button.platform}
            >
                <Icon name={button.iconName} />
            </ShareButton>
        );
    };

    return (
        <PargodaModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            sx={{ width: '350px', maxWidth: '100%' }}
        >
            <DialogContent>
                <Grid container justifyContent="center">
                    <Grid
                        item
                        xs={12}
                        display={'flex'}
                        justifyContent={'center'}
                        sx={{ mb: 3 }}
                    >
                        <Typography
                            variant={'h4'}
                            color={theme.palette.grey[600]}
                        >
                            {modalTitle}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ mb: 3 }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            {shareButtons.map((button) =>
                                renderShareButton(button)
                            )}
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
        </PargodaModal>
    );
};

export default ShareJobApplicationModal;
